document.addEventListener('DOMContentLoaded', function () {
  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const button = document.getElementById("cart-checkout");

      if (button) {
        button.addEventListener("click", function() {
            const newBtn = button.cloneNode(true);
            button.parentNode.replaceChild(newBtn, button);
            BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');  
        });
      }
    }, 2000);
  }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (
          item.target.classList.contains("totals__subtotal-value")
        ) {
          setTimeout(() => {
            const buttonMiniCart = document.getElementById("CartDrawer-Checkout");

            buttonMiniCart.addEventListener("click", function() {
                const newBtn = buttonMiniCart.cloneNode(true);
                buttonMiniCart.parentNode.replaceChild(newBtn, buttonMiniCart);
                BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');  
            });
          }, 1000);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}